export const campWiseStuAttendanceApi = {
    heading:[
        
        {
            head:"ID"
        },
        {
            head:"Name"
        },
        {
            head:"Class"
        },
        {
            head:"Date"
        },
        {
            head:"In Time"
        },
        {
            head:"Out Time"
        },
        {
            head:"Type"
        },
    ],
    data:[
      {
        id:1,
        name:"Sahara",
        class:"Class 4",
        date:"10-05-2023",
        intime:"09:30 AM",
        outtime:"10:30 Am",
        type:"Present"

      },
      {
        id:1,
        name:"Sahara",
        class:"Class 4",
        date:"10-05-2023",
        intime:"09:30 AM",
        outtime:"10:30 Am",
        type:"Present"

      },
      {
        id:999,
        name:"Sahara",
        class:"Class 4",
        date:"10-05-2023",
        intime:"09:30 AM",
        outtime:"10:30 Am",
        type:"Absent"

      },
     
    
      
     
   
       
    ]
}